module.exports = __webpack_public_path__ + "img/1 (41).63431070.png";